import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

const state = {
  user: {
    employeeId: null,
    firstName: null,
    lastName: null
  },
  authStatus: {
    loggingIn: false,
    accessToken: null,
    refreshToken: null,
    authError: false,
    errorMessage: false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
